module.exports = __webpack_public_path__ + "img/medical-mask-knowledgeTrail.3e28a490.svg";